// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import t from 'tcomb';

const InvoiceMassProcess = t.struct({
    dealerInvoiceNumber: t.maybe(t.String),
    invoiceRequestNumber: t.String,
    invoiceSentDate: t.maybe(t.Number),
    netAmount: t.Number,
    requestDate: t.maybe(t.Number),
    status: KeyValuePair,
    taxAmount: t.Number,
    totalAmount: t.Number
}, {
    name: 'InvoiceMassProcess',
    strict: true
});

export const getDefaultState = () => new InvoiceMassProcess({
    dealerInvoiceNumber: '',
    invoiceRequestNumber: '',
    invoiceSentDate: null,
    netAmount: 0,
    requestDate: null,
    status: getKeyValuePairDefaultState(),
    taxAmount: 0,
    totalAmount: 0
});

export default InvoiceMassProcess;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/invoice-mass-process.js